import BirthdayService from './BirthdayService';

interface Props {
    birthdayThisYear: string;
    daysUntil: number;
    today: Date;
}

const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function formatRailDate(iso: string): string {
    const d = new Date(iso);
    return `${d.getDate()} ${MONTH_SHORT[d.getMonth()]}`;
}

const DateRail = ({ birthdayThisYear, daysUntil, today }: Props) => {
    // daysUntil may have been computed on the server with a slightly different "today" anchor;
    // recompute against the browser's current day so a long-open tab survives a midnight rollover
    // without showing a stale "in 1 day" for what is now today.
    const target = new Date(birthdayThisYear);
    const liveDaysUntil = BirthdayService.daysUntil(target, today);
    const effective = Number.isFinite(liveDaysUntil) ? Math.max(0, liveDaysUntil) : daysUntil;
    const isToday = effective === 0;

    return (
        <div className={`bd-rail mt-3 ${isToday ? 'bd-rail--today' : ''}`}>
            <div className="bd-rail-date">{formatRailDate(birthdayThisYear)}</div>
            <div className="bd-rail-rel">{BirthdayService.relativeLabel(effective)}</div>
        </div>
    );
};

export default DateRail;
